import ConfettiComponent from "@/components/confetti";
import { SupportMessage } from "@/components/layout-loading/support-message";
import { Button } from "@/components/ui/button";
import { useStepper } from "@/components/ui/stepper";
import { useApi } from "@/hooks/useApi";
import { useTranslation } from "@/hooks/useTranslation";
import { useEffect, useState } from "react";

export const SetupTeamCreationFinishPage = () => {
  const api = useApi();
  const { prevStep } = useStepper();
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    finishSetup();
  }, []);

  const finishSetup = async () => {
    try {
      setIsLoading(true);
      await api.post(`/my/team/setup/finish`);
      removeLocalStorage();
      setIsSuccess(true);
    } catch (error) {
      setIsSuccess(false);
    } finally {
      setIsLoading(false);
    }
  };

  const removeLocalStorage = () => {
    localStorage.removeItem("setup-team-creation-survey");
    localStorage.removeItem("setup-team-creation-infos");
    localStorage.removeItem("setup-team-creation-subscription-type");
    localStorage.removeItem("referralCode");
  };

  const redirectToHome = () => {
    window.location.href = "/";
  };

  if (isLoading) {
    return <div>{t("setup.teamCreation.finish.loading")}</div>;
  }

  if (!isSuccess) {
    return (
      <div className="space-y-5 text-center">
        <h1 className="text-2xl font-bold text-primary">
          {t("setup.teamCreation.finish.error.title")}
        </h1>
        <p>{t("setup.teamCreation.finish.error.description")}</p>
        <SupportMessage />
        <Button onClick={() => prevStep()}>
          {t("setup.teamCreation.finish.buttons.retry")}
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-5 text-center">
      <h1 className="text-2xl font-bold text-primary">
        {t("setup.teamCreation.finish.success.title")}
      </h1>
      <p
        className="text-md"
        dangerouslySetInnerHTML={{
          __html: t("setup.teamCreation.finish.success.description"),
        }}
      />
      <Button onClick={redirectToHome}>
        {t("setup.teamCreation.finish.buttons.letsGo")}
      </Button>
      <ConfettiComponent />
    </div>
  );
};
